export default "__VITE_ASSET__2ee01794__"